import React from 'react';
/**
 * This is an accessible wrapper for content that can be expanded or collapsed.
 * It provides a child function for making the expanded user control and content
 * accessible.
 *
 * @example
 * ```typescript
 * function MyExpandedSection() {
 * 	const [expanded, setExpanded] = React.useState(false);
 * 	return (
 * 		<ExpandableSection
 * 			expanded={expanded}
 * 			onToggle={newExpanded => setExpanded(newExpanded)}
 * 		>
 * 			{expandableProps => (
 * 				<div>
 * 					<button {...expandableProps.getControlProps()}>Title</button>
 * 					<div
 * 						{...expandableProps.getContentProps()}
 * 						style={{ display: expanded ? 'block' : 'none' }}
 * 					>
 * 						Content
 * 					</div>
 * 				</div>
 * 			)}
 * 		</ExpandableSection>
 * 	);
 * }
 * ```
 */
export function ExpandableSection(props) {
  var sectionId = "id".concat(Math.random());
  var getControlProps = function getControlProps() {
    return {
      tabIndex: 0,
      onClick: function onClick() {
        var _props$onToggle;
        (_props$onToggle = props.onToggle) === null || _props$onToggle === void 0 ? void 0 : _props$onToggle.call(props, !props.expanded);
      },
      role: 'button',
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter') {
          var _props$onToggle2;
          event.preventDefault();
          (_props$onToggle2 = props.onToggle) === null || _props$onToggle2 === void 0 ? void 0 : _props$onToggle2.call(props, !props.expanded);
        }
      },
      'aria-expanded': props.expanded,
      'aria-controls': sectionId
    };
  };
  var getContentProps = function getContentProps() {
    return {
      id: sectionId,
      'aria-hidden': !props.expanded
    };
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children({
    getControlProps: getControlProps,
    getContentProps: getContentProps
  }));
}